import { CustomOrderType } from './CustomOrderType';

export interface CartEntryLike {
  readonly product: {
    readonly clickAndCollect: boolean;
    readonly homeDelivery: boolean;
  };
}

const getCartCustomOrderTypeForEntries = <TEntry extends CartEntryLike>(
  entries: ReadonlyArray<TEntry>
): CustomOrderType => {
  let hasCollectAtStoreOnlyProduct = false;
  let hasHomeDeliveryOnlyProduct = false;

  for (const {
    product: { clickAndCollect, homeDelivery }
  } of entries) {
    if (clickAndCollect && !homeDelivery) {
      hasCollectAtStoreOnlyProduct = true;
    }
    if (homeDelivery && !clickAndCollect) {
      hasHomeDeliveryOnlyProduct = true;
    }
  }

  return hasCollectAtStoreOnlyProduct && !hasHomeDeliveryOnlyProduct
    ? CustomOrderType.COLLECT_AT_STORE
    : CustomOrderType.HOME_DELIVERY;
};

export default getCartCustomOrderTypeForEntries;
